<div class="otp-step">
  @if (verificationTotal() > 1) {
    <div class="otp-progress">
      {{ 'create_partner_component.otp_progress_step' | translate : { current: verificationStep(), total: verificationTotal() } }}
    </div>
  } @else {
    <div class="otp-progress">
      {{ 'create_partner_component.otp_progress_last' | translate }}
    </div>
  }

  <div class="calio-pc-heading">
    {{ 'create_partner_component.email_otp_heading' | translate }}
  </div>
  <div class="calio-pc-subtitle">
    {{ 'create_partner_component.email_otp_subtitle' | translate : { email: email() } }}
  </div>

  <form class="form-group" #otpForm="ngForm">
    <div class="calio-pc-reseller-form-group mb-2">
      <label class="calio-reseller-label">
        {{ 'create_partner_component.otp_code_label' | translate | addRequired }}
      </label>
      <app-otp-input
        [length]="6"
        [ariaLabel]="'create_partner_component.otp_code_label' | translate"
        [disabled]="isSending$()"
        [invalid]="!!errorMessageKey$()"
        (otpChange)="onCodeInput($event)"
        (otpEnterPress)="verifyOtp()"
      />
      @if (errorMessageKey$()) {
        <div class="calio-pc-reseller-invalid-feedback">
          {{ 'error_messages.' + errorMessageKey$() | translate : { time: blockedTime$() } }}
        </div>
      }
      @if (expiresAt$()) {
        <div class="otp-expiry-hint">
          {{ 'create_partner_component.otp_expires_hint' | translate : { minutes: ttlMinutes$() } }}
          {{ 'create_partner_component.otp_limit_hint' | translate : { max: maxSendsPerHour } }}
        </div>
      }
      @if (isSending$()) {
        <div class="otp-code-sent">
          {{ 'create_partner_component.otp_sending' | translate }}
        </div>
      } @else if (codeSentConfirm$()) {
        <div class="otp-code-sent">
          {{ 'create_partner_component.otp_code_sent' | translate }}
        </div>
      }
    </div>

    <div class="col-md-12 calio-pc-button-container mt-4">
      <button
        id="verify_registration_email_otp"
        type="submit"
        [disabled]="otpCode$().length !== 6 || showLoader$() || isSending$()"
        class="calio-pc-reseller-button signin-button"
        (click)="verifyOtp()"
      >
        @if (!showLoader$()) {
          <span>{{ 'create_partner_component.otp_verify_button' | translate }}</span>
        } @else {
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        }
      </button>
    </div>
  </form>

  <div class="otp-footer-actions mt-3">
    <div class="otp-edit">
      <button type="button" class="link" (click)="editContact()">
        {{ 'create_partner_component.otp_edit_email' | translate }}
      </button>
    </div>

    <div class="otp-resend">
      {{ 'create_partner_component.otp_resend_text' | translate }}&nbsp;
      @if (resendCooldown$() > 0) {
        <span class="otp-resend-cooldown">{{ 'create_partner_component.otp_resend_in' | translate : { seconds: resendCooldown$() } }}</span>
      } @else {
        <button
          type="button"
          class="link"
          [disabled]="resendBlocked$() || isSending$()"
          (click)="resendOtp()"
        >
          {{ 'create_partner_component.otp_resend_link' | translate }}
        </button>
      }
    </div>
  </div>
</div>
